import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=566bb5ea&"
import script from "./Doc.vue?vue&type=script&lang=js&"
export * from "./Doc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports